import * as Yup from "yup";

const suprimentoSangriaValidator = Yup.object().shape({
  valor: Yup.number().required("Valor"),
  meioPagamentoId: Yup.number().required("Meio de Pagamento"),
});

export default suprimentoSangriaValidator;
